import type { BlogDocument } from "@adjust/libs/database/blogs";

export const TOTAL_BLOGS_PER_PAGE = 10;

export type PageProps = {
  blogs: BlogDocument[];
  page: number;
  total: number;
};
